module.exports = __webpack_public_path__ + "img/caas2-m@2.3fc4b738.webp";